import React from 'react'
import AllPeriodsPageComp from '../components/AllPeriodsPageComp'

const AllPeriodsPage = () => {
  return <AllPeriodsPageComp />
}

export default AllPeriodsPage
